<div class="row">
    <div class="col-md-12">
        <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
            <mat-card-content class="mat-mdc-card-content text-right">
                <span class="title"> {{ 'ChooseProduct' | translate}}</span>
                <div class="row m-t-10">
                    <div class="col-md-6" *ngFor="let item of Contract?.listItem;">
                        <mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
                            <mat-card-header class="mat-mdc-card-header bg-primary p-10 m-b-15">
                                <mat-card-title class="mat-mdc-card-title text-white">
                                    {{item.productName}}
                                </mat-card-title>
                                <div class="check">
                                    <mat-checkbox color="primary">
                                    </mat-checkbox>
                                </div>
                            </mat-card-header>
                            <mat-card-content class="mat-mdc-card-content text-center">
                                <div class="row">
                                    <div class="col-md-3">
                                        <span class="UploadPhotosTitle"> {{ 'UploadPhotos' | translate}}</span>
                                    </div>
                                    <div class="col-md-6">
                                        <label class="upload-label" for="file-input">
                                            <i-tabler name="photo-up" class="icon-20 icon d-flex"></i-tabler>
                                            <span>
                                                {{ 'UploadImagesAfterInstallation' | translate}}
                                            </span>
                                            <input type="file" id="file-input" (change)="onFileSelected($event)"
                                                accept="image/*" />
                                        </label>
                                    </div>
                                    <div class="row m-t-30" *ngIf="imageUrls.length!=0">
                                        <div class="col-md-3" *ngFor="let imageUrl of imageUrls">
                                            <img [src]="imageUrl" width="100%" height="100%"
                                                class="mat-mdc-card-image mdc-card__media" />
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>

                <div *ngIf="formErrors.length>0">
                    <div *ngFor="let error of formErrors">
                        <p class="validation-error">{{ error }}
                        </p>
                    </div>
                </div>
                <div class="divBtn">
                    <button class="btnViewWarrantyBeforeSend" (click)="ViewWarrantyBeforeSend()">
                        {{ 'ViewWarrantyBeforeSend' | translate}}
                    </button>

                    <button mat-button class="Cancelbtn" (click)="Cancel()"> {{ 'Cancel' | translate}}</button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>